import React, { useContext } from "react";
import IPriceDetailUI from "../../../models/IPriceDetailUI";
import { NumericFormat } from "react-number-format";
import SupplierContext from "../../../contexts/SupplierContext";
import styled from "styled-components";
import IDiscount from "../../../models/IDiscount";
import PriceUpchargeTypeEnum from "../../../models/PriceUpchargeTypeEnum";
import ICurrency from "../../../models/ICurrency";
import OrderEntryService from "../../../services/OrderEntryService";
import * as _ from "lodash-es";
import OwLabel from "../OwLabel/OwLabel";
import { FormattedNumber } from "react-intl";
import CatalogService from "@services/CatalogService";
import CurrenciesEnum from "@models/CurrenciesEnum";

type Props = {
    priceDetail: IPriceDetailUI;
    prefix: string;
    isEcomView?: boolean;
    currency?: ICurrency;
    baseCurrency?: ICurrency;
    exchangeRate?: number;
};

export const PricePerUnit = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const symbol = props.currency ? OrderEntryService.getCurrencySymbol(props.currency?.name || "") : props.prefix;

    const calculatePriceFromCurrency = (initPrice: number) => {
        if (props.baseCurrency && props.currency) {
            return OrderEntryService.convertCurrency(initPrice, props.baseCurrency, props.currency, props.exchangeRate);
        }
        return initPrice;
    };

    const getDiscountAmount = (discount: IDiscount) => {
        let detail = "";

        if (discount.discount_type_id === PriceUpchargeTypeEnum.PERCENT) {
            detail = `(${discount.discount}%)`;
        } else {
            let amount = discount.discount;

            if (props.baseCurrency && props.currency) {
                amount = calculatePriceFromCurrency(discount.discount);
            }

            detail = `(${symbol}${amount})`;
        }

        return <DiscountDetail>{detail}</DiscountDetail>;
    };

    // @ts-expect-error
    const mainPriceUnit = parseInt(calculatePriceFromCurrency(props.priceDetail?.discountedPrice || 0));
    let displayedMainPriceUnit = "";
    let priceError = false;

    if (_.isNaN(mainPriceUnit)) {
        priceError = true;
    } else {
        displayedMainPriceUnit = mainPriceUnit.toString();
    }

    return (
        <div className={"PricePerUnit d-flex"}>
            {props.isEcomView ? (
                priceError ? (
                    <div>
                        <OwLabel title={"price_error"} leftIconClass={"fas fa-exclamation-triangle text-warning"} />
                    </div>
                ) : (
                    <>
                        <div className={"currency-symbol"}>{symbol}</div>
                        <div className={"price-leading-numbers"}>
                            <FormattedNumber currency={props.currency?.name} value={Number(displayedMainPriceUnit)} />
                        </div>
                        <div className={"price-decimal-numbers"}>
                            {calculatePriceFromCurrency((props.priceDetail?.discountedPrice || 0) % 1)
                                .toFixed(2)
                                .substr(2)}
                        </div>
                    </>
                )
            ) : (
                <>
                    <NumericFormat
                        value={calculatePriceFromCurrency(props.priceDetail.discountedPrice)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={props.prefix}
                        decimalScale={supplierModel.pricing_precision || 2}
                        fixedDecimalScale={true}
                    />
                </>
            )}
            {props.priceDetail.discount ? (
                <OriginalPriceDetail className={"text-muted"}>
                    <OriginalPrice>
                        <NumericFormat
                            value={calculatePriceFromCurrency(props.priceDetail.originalPrice)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={props.prefix}
                            decimalScale={supplierModel.pricing_precision || 2}
                            fixedDecimalScale={true}
                            type={"text"}
                        />
                    </OriginalPrice>
                    <div>{getDiscountAmount(props.priceDetail.discount)}</div>
                </OriginalPriceDetail>
            ) : null}
        </div>
    );
};

const OriginalPriceDetail = styled.div`
    font-size: 0.9rem;
    margin-left: 0.5rem;
`;

const OriginalPrice = styled.div`
    text-decoration: line-through;
`;

const DiscountDetail = styled.span``;
